import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { SidebarContext } from "../Sidebar/SidebarProvider";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import ExpensesList from "./ExpensesList";
import ExpensesToolbar, {
  STATUS_FILTER_OPEN,
  STATUS_FILTER_CLOSED,
} from "./ExpensesToolbar";
import {
  getExpenseDocuments,
  createExpenseDocument,
  deleteExpenseDocument,
} from "../../api/Expenses/expenseDocumentsApi";

const Expenses = () => {
  const navigate = useNavigate();
  const { isMinimized, contentMargin } = useContext(SidebarContext);

  const [documents, setDocuments] = useState([]);
  const [statusFilter, setStatusFilter] = useState(STATUS_FILTER_OPEN); // por defecto solo abiertos (no closed)
  const marginLeft = isMinimized ? "3em" : "3em";

  const [deleteTarget, setDeleteTarget] = useState(null);

  const filteredDocuments = documents.filter((doc) => {
    const isClosed = doc.Status === "closed";
    if (statusFilter === STATUS_FILTER_OPEN) return !isClosed;
    if (statusFilter === STATUS_FILTER_CLOSED) return isClosed;
    return true; // all
  });

  const handleDeleteRequest = (doc) => {
    setDeleteTarget(doc);
  };

  const handleCancelDelete = () => {
    setDeleteTarget(null);
  };

  const handleConfirmDelete = async () => {
    if (!deleteTarget) return;

    try {
      await deleteExpenseDocument(deleteTarget.id);
      setDeleteTarget(null);
      loadDocuments();
    } catch (e) {
      alert(e?.response?.data?.error || "No se pudo eliminar el documento");
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return navigate("/login");

    try {
      const decoded = jwtDecode(token);
      if (decoded.exp < Date.now() / 1000) {
        localStorage.removeItem("token");
        navigate("/login");
      }
    } catch {
      navigate("/login");
    }
  }, [navigate]);

  const loadDocuments = async () => {
    const data = await getExpenseDocuments();
    setDocuments(data);
  };

  useEffect(() => {
    loadDocuments();
  }, []);

  const handleCreate = async () => {
    const doc = await createExpenseDocument();
    navigate(`/expenses/${doc.id}`);
  };

  const handleRowClick = (doc) => {
    navigate(`/expenses/${doc.id}`);
  };

  return (
    <Box sx={{ marginLeft, ...contentMargin, mt: 2, mr: 2 }}>
      <ExpensesToolbar
        onCreate={handleCreate}
        statusFilter={statusFilter}
        onStatusFilterChange={setStatusFilter}
      />
      <ExpensesList
        rows={filteredDocuments}
        onRowClick={handleRowClick}
        onDelete={handleDeleteRequest}
      />
      <Dialog open={Boolean(deleteTarget)} onClose={handleCancelDelete}>
        <DialogTitle>Eliminar documento</DialogTitle>

        <DialogContent>
          <Typography>
            ¿Seguro que deseas eliminar el documento{" "}
            <strong>{deleteTarget?.DocumentNumber}</strong>?
          </Typography>
          <Typography color="text.secondary" sx={{ mt: 1 }}>
            Esta acción no se puede deshacer.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancelDelete}>Cancelar</Button>
          <Button
            onClick={handleConfirmDelete}
            color="error"
            variant="contained"
          >
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Expenses;
